import React from 'react';

import DashboardHeader from '../../../shared/components/DashboardHeader';
import TemplatesTable from "../../../shared/components/admin/tables/TemplatesTable";
import ClientsTable from '../../../shared/components/admin/tables/ClientsTable';

export default () =>
    <>
        <DashboardHeader title="Klienci"/>
        <div className="tab-content">
            <div className="tab-pane fade show active">
                <div className="card">
                    <ClientsTable/>
                </div>
            </div>
        </div>
    </>
